module.exports = __webpack_public_path__ + "img/notice1135.4c54d93d.png";